<template>
    <div class="top-bar-tabs">
        <div class="tabs">
            <div class="tab-indicator" :style="{ transform: `translateX(${indicatorPosition}px)` }"></div>
            <div class="tab" v-for="(tab, index) in tabs" :key="tab" :class="{ active: activeTab === tab }"
                @click="changeTab(tab, index)">
                {{ tab.name }}
            </div>
        </div>
    </div>
</template>

<script>
import TopBarStyle from '!raw-loader!@/assets/top-bar.scss';

export default {
    name: 'TopBar_genai',
    data() {
        return {
            activeTab: 'service_client',
            indicatorPosition: 0,
        };
    },
    props: {
        tabs: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
    },
    mounted() {
        this.appendStyle();
        this.updateIndicatorPosition();
    },
    methods: {
        changeTab(tab, index) {
            this.activeTab = tab.value;
            this.updateIndicatorPosition(index);
        },
        updateIndicatorPosition(index = 0) {
            const tabWidth = 200;
            this.indicatorPosition = index * tabWidth;
        },
        appendStyle() {
            const iframe = document.getElementById('cleed-frame');
            const doc = iframe.contentWindow.document;

            let app_style = doc.createElement('style');
            app_style.innerHTML = TopBarStyle;
            doc.head.appendChild(app_style);
        },
    },
};
</script>